export default __webpack_public_path__ + "static/media/widgets.efcdce65.svg";